<div class="flex flex-col h-full w-full">
  <app-breadcrumb
    [path]="vcPatientDetails?.current_place?.data?.room?.service_unit?.department?.[0]?.code"
    [station]="vcPatientDetails?.current_place?.data?.room?.service_unit?.code"
    [filter]="vcPatientDetails?.current_place?.data?.room?.code"
    [title]="
      vcPatientDetails
        ? (vcPatientDetails?.patient?.data?.surname || '') +
          ', ' +
          (vcPatientDetails?.patient?.data?.name || '') +
          ', ' +
          ('GENERAL.' + (vcPatientDetails?.patient?.data?.gender || '') | translate) +
          ', ' +
          (vcPatientDetails?.patient?.data?.birth_date
            | date: ('GENERAL.date_format' | translate)) +
          ' (' +
          (vcPatientDetails?.patient?.data?.birth_date | calAge) +
          ') ' +
          'A: ' +
          (vcPatientDetails?.case?.data?.admission_date
            | date: ('GENERAL.date_format' | translate)) +
          (vcPatientDetails?.case?.data?.discharge_date
            ? ', ' +
              ('COMPONENT.PAGE_PATIENT_LIST.planned_discharge_date' | translate) +
              ': ' +
              (vcPatientDetails?.case?.data?.discharge_date
                | date: ('GENERAL.date_format' | translate)) +
              ' (' +
              (calculateHospitalStayDays(
                vcPatientDetails?.case?.data?.admission_date,
                vcPatientDetails?.case?.data?.discharge_date
              ) | number: '1.0-0') +
              ')'
            : '')
        : ''
    "
    [useCustomTitle]="false"
  >
    <div class="flex justify-between items-center w-full">
      <div class="block justify-start w-full"></div>
      <!-- Presentation Mode -->
      <div
        class="presentation-wrapper"
        [class.active]="toggleState"
        (click)="handleToggle(!toggleState)"
      >
        <span class="presentation-label">{{ 'PRESENTATION.mode' | translate }}</span>
        <mat-icon [ngClass]="toggleState ? 'text-[var(--primary-color)]' : 'text-gray-500'">
          {{ toggleState ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </div>
    </div>
  </app-breadcrumb>

  <!-- Tabs and tab contents -->
  <div class="flex-grow flex flex-col bg-white overflow-hidden">
    <mat-tab-group
      (selectedTabChange)="changeTab($event)"
      [selectedIndex]="currentTab"
      animationDuration="0ms"
      class="h-full flex flex-col"
    >
      <!-- #region Overview Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center">
            <span>{{ 'COMPONENT.PATIENT_DETAILS.overview' | translate }}</span>
            &nbsp;
            <mat-spinner
              *ngIf="loadingOverview"
              [ngClass]="{ 'patient-details-selected-tab-spinner': currentTab === 0 }"
              class="tab-progress-spinner"
              diameter="20"
            ></mat-spinner>
          </div>
        </ng-template>

        <div class="h-full overflow-auto relative">
          <app-patient-overview
            (changedOverviewData)="onOverviewDataChange($event)"
            *ngIf="currentTab === 0 && vcPatientDetails"
            [caseOverview]="vcCaseOverview"
            [patientDetailsI18n]="vcPatientDetails?.patient?.i18n"
            [vcPatientDetails]="vcPatientDetails"
          ></app-patient-overview>

          <div *ngIf="loadingOverview" class="patient-details-tab-spinner-cover">
            <mat-spinner class="tab-progress-spinner"></mat-spinner>
          </div>
        </div>
      </mat-tab>
      <!-- #endregion -->

      <!-- #region Curve Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex gap-1 items-center">
            <span>{{ 'COMPONENT.PATIENT_DETAILS.curve' | translate }}</span>
            &nbsp;
            <mat-spinner
              *ngIf="loadingCurve"
              [ngClass]="{ 'patient-details-selected-tab-spinner': currentTab === 1 }"
              class="tab-progress-spinner"
              diameter="20"
            ></mat-spinner>
          </div>
        </ng-template>

        <div class="h-full relative">
          <app-patient-curve
            (groupsChange)="onCurveGroupsChange($event)"
            *ngIf="currentTab === 1"
            [patientNameAndDob]="patientNameAndDob"
            [vcGroups]="vc_CurveGroups"
          ></app-patient-curve>

          <div *ngIf="loadingCurve" class="patient-details-tab-spinner-cover">
            <mat-spinner class="tab-progress-spinner"></mat-spinner>
          </div>
        </div>
      </mat-tab>
      <!-- #endregion -->

      <!-- #region Record Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex gap-1 items-center">
            <span>{{ 'COMPONENT.PATIENT_DETAILS.file' | translate }}</span>
            &nbsp;
            <mat-spinner
              *ngIf="loadingRecord"
              [ngClass]="{ 'patient-details-selected-tab-spinner': currentTab === 2 }"
              class="tab-progress-spinner"
              diameter="20"
            ></mat-spinner>
          </div>
        </ng-template>

        <div class="h-full relative">
          <app-med-view
            *ngIf="currentTab === 2"
            [patientRecordData]="patientRecordData"
          ></app-med-view>
          <div *ngIf="loadingRecord" class="patient-details-tab-spinner-cover">
            <mat-spinner class="tab-progress-spinner"></mat-spinner>
          </div>
        </div>
      </mat-tab>
      <!-- #endregion -->

      <!-- #region Workflow Tab -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex gap-1 items-center">
            <span>{{ 'COMPONENT.PATIENT_DETAILS.workflow' | translate }}</span>
            &nbsp;
            <mat-spinner
              *ngIf="loadingWorkflow"
              [ngClass]="{ 'patient-details-selected-tab-spinner': currentTab === 3 }"
              class="tab-progress-spinner"
              diameter="20"
            ></mat-spinner>
          </div>
        </ng-template>
        <!-- workflow -->
        <div class="h-full relative">
          <app-workflow-tabs
            (viewContentChange)="onViewContentChange($event)"
            *ngIf="currentTab === 3"
            [filterValue]="filterValue"
            [patientDetails]="vcPatientDetails"
            [tasks]="vc_CommunicationMessages ?? []"
          ></app-workflow-tabs>

          <div *ngIf="loadingWorkflow" class="patient-details-tab-spinner-cover">
            <mat-spinner class="tab-progress-spinner"></mat-spinner>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
